import React, { useCallback, useState } from "react";
import useApi from "./useApi";

export default function useVersion() {
  const api = useApi();
  const [version, setVersion] = useState<string | null>(null);
  const [deployedAt, setDeployedAt] = useState<string | null>(null);
  const [messagingDeployedAt, setMessagingDeployedAt] = useState<string | null>(null);
  const [showReloadModal, setShowReloadModal] = useState(false);

  function resetModal() {
    setShowReloadModal(false);
  }

  const getVersion = useCallback(async () => {
    try {
      let response = await api.admin.get("version");
      if (!response.ok) {
        response = await api.messaging.get("version");
        if (!response.ok) return;
      }
      const data = await response.json();
      const newVersion = typeof data === "string" ? data : data?.version;
      if (typeof data !== "string" && data?.deployedAt) {
        setDeployedAt(data.deployedAt);
      }
      if (version == null) {
        setVersion(newVersion);
      } else if (version != newVersion) {
        setShowReloadModal(true);
      }
    } catch {
      // Network error — swallow silently, retry on next interval
    }
  }, [api.admin, api.messaging, version]);

  const getMessagingVersion = useCallback(async () => {
    try {
      const response = await api.messaging.get("version");
      if (!response.ok) return;
      const data = await response.json();
      if (data?.deployedAt) setMessagingDeployedAt(data.deployedAt);
    } catch {
      // Messaging API unreachable — not critical
    }
  }, [api.messaging]);

  React.useEffect(() => {
    if (version == null) {
      getVersion();
    }
    const interval = setInterval(getVersion, 1000 * 30);
    return () => clearInterval(interval);
  }, [api.messaging, getVersion, version]);

  React.useEffect(() => {
    getMessagingVersion();
    const interval = setInterval(getMessagingVersion, 1000 * 30);
    return () => clearInterval(interval);
  }, [getMessagingVersion]);

  return { showReloadModal, resetModal, version, deployedAt, messagingDeployedAt };
}
